/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FileDto } from '../models/file-dto';
import { storageControllerDeleteFileV1 } from '../fn/storage/storage-controller-delete-file-v-1';
import { StorageControllerDeleteFileV1$Params } from '../fn/storage/storage-controller-delete-file-v-1';
import { storageControllerDeleteManyV1 } from '../fn/storage/storage-controller-delete-many-v-1';
import { StorageControllerDeleteManyV1$Params } from '../fn/storage/storage-controller-delete-many-v-1';
import { storageControllerDownloadFileV1 } from '../fn/storage/storage-controller-download-file-v-1';
import { StorageControllerDownloadFileV1$Params } from '../fn/storage/storage-controller-download-file-v-1';
import { storageControllerUploadFilesV1 } from '../fn/storage/storage-controller-upload-files-v-1';
import { StorageControllerUploadFilesV1$Params } from '../fn/storage/storage-controller-upload-files-v-1';

@Injectable({ providedIn: 'root' })
export class StorageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storageControllerDownloadFileV1()` */
  static readonly StorageControllerDownloadFileV1Path = '/api/v1/storage/download/{url}';

  /**
   * 파일 다운로드.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerDownloadFileV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDownloadFileV1$Response(params: StorageControllerDownloadFileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'url'?: string;
}>> {
    const obs = storageControllerDownloadFileV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파일 다운로드.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerDownloadFileV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDownloadFileV1(params: StorageControllerDownloadFileV1$Params, context?: HttpContext): Observable<{
'url'?: string;
}> {
    const resp = this.storageControllerDownloadFileV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'url'?: string;
}>): {
'url'?: string;
} => r.body)
    );
  }

  /** Path part for operation `storageControllerUploadFilesV1()` */
  static readonly StorageControllerUploadFilesV1Path = '/api/v1/storage';

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerUploadFilesV1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storageControllerUploadFilesV1$Response(params: StorageControllerUploadFilesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileDto>>> {
    const obs = storageControllerUploadFilesV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerUploadFilesV1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storageControllerUploadFilesV1(params: StorageControllerUploadFilesV1$Params, context?: HttpContext): Observable<Array<FileDto>> {
    const resp = this.storageControllerUploadFilesV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FileDto>>): Array<FileDto> => r.body)
    );
  }

  /** Path part for operation `storageControllerDeleteManyV1()` */
  static readonly StorageControllerDeleteManyV1Path = '/api/v1/storage';

  /**
   * 여러 파일 삭제.
   *
   * 여러 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerDeleteManyV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storageControllerDeleteManyV1$Response(params: StorageControllerDeleteManyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
    const obs = storageControllerDeleteManyV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 여러 파일 삭제.
   *
   * 여러 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerDeleteManyV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storageControllerDeleteManyV1(params: StorageControllerDeleteManyV1$Params, context?: HttpContext): Observable<{
'count'?: number;
}> {
    const resp = this.storageControllerDeleteManyV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'count'?: number;
}>): {
'count'?: number;
} => r.body)
    );
  }

  /** Path part for operation `storageControllerDeleteFileV1()` */
  static readonly StorageControllerDeleteFileV1Path = '/api/v1/storage/{url}';

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storageControllerDeleteFileV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDeleteFileV1$Response(params: StorageControllerDeleteFileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    const obs = storageControllerDeleteFileV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storageControllerDeleteFileV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storageControllerDeleteFileV1(params: StorageControllerDeleteFileV1$Params, context?: HttpContext): Observable<FileDto> {
    const resp = this.storageControllerDeleteFileV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

}
